export const formatNumber = (number: number, decimals: number = 2) => {
  // add decimals only if number is not round
  return Number.isInteger(number) ? number.toString() : number.toFixed(decimals);
};
